import script from "./PottingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PottingTable.vue?vue&type=script&setup=true&lang=js"

import "./PottingTable.vue?vue&type=style&index=0&id=d7306a54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7306a54"]])

export default __exports__